import script from "./VPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPanel.vue?vue&type=script&setup=true&lang=ts"

import "./VPanel.vue?vue&type=style&index=0&id=606f6a89&lang=scss"

const __exports__ = script;

export default __exports__